<template>
    <v-container fluid class='d-flex flex-column align-center'>

        <div class='deep-orange--text font-weight-bold display-2 text-center'>{{$t('dash_overview.sell_chance')}}</div>

        <div class='mb-7 mt-3 title blue-grey--text'>{{$t('dash_overview.upgrade_options')}}</div>

        <v-row no-gutters class='d-flex' >

            <v-col class='d-flex align-center' cols='auto' v-if="!isMobile">
                <v-divider class='line' horizontal></v-divider>
            </v-col>

            <v-col class='d-flex align-center' cols='auto'>
                <v-btn @click='goToPlans' class='btn-footer-plans' rounded outlined x-large color="#006064">{{$t('dash_overview.see_plans')}}</v-btn>
            </v-col>
            
            <v-col class='d-flex align-center' v-if="!isMobile" cols='auto'>
                <v-divider class='line' horizontal></v-divider>
            </v-col>

        </v-row>

    </v-container>
</template>

<script>
export default {
    name: 'FooterContainer',
    methods: {
        goToPlans() {

            return window.open('https://provedor.querointernet.net/', '_blank')

        }
    },

}
</script>
<style scoped>
.line {

    border: 1px solid;
    width: 45vh !important;
    border-color: #4ec5c1;


}
</style>